import * as Sentry from '@sentry/browser';
import { ErrorType } from '../../utils/types';
import {
  fallbackToDefaultStateAction,
  populateAnalysisAction,
  populateAnalysisThunk,
} from '../slices/analyses';
import { AnalysisStatus } from '../../utils/apollo/graphqlSchema';
import { IErrorHandler } from '../middleware/errorCatcher';
import { AppThunkDispatch } from '../store';
import analysesSlice from '../slices/analyses/analysesSlice';
import toastMessage from '../../utils/toastMessage';

export const errorHandler: IErrorHandler<AppThunkDispatch> = (
  error,
  lastAction,
  storeApi,
) => {
  Sentry.captureException(error);

  console.error(error);
  console.info(lastAction);
  const { type, payload } = lastAction;
  if (
    error.message === ErrorType.NullPointerException &&
    type === populateAnalysisAction.toString()
  ) {
    if (payload?.analysis?.id) {
      storeApi.dispatch(
        populateAnalysisThunk({
          analysis: { ...payload.analysis, status: AnalysisStatus.Failed },
        }),
      );
    }
    return;
  }
  if (lastAction.type.startsWith(analysesSlice.name + '/')) {
    storeApi.dispatch(fallbackToDefaultStateAction(payload.id));
    toastMessage({
      message: 'Something went wrong. Loading the chart with default settings.',
      type: 'error',
    });
  }
};

export default errorHandler;
